import * as actionTypes from 'shared/state/auth/actionTypes';
import { useCookies } from 'react-cookie';
import { toast } from 'react-toastify';

//
import { makeAPIRequest } from 'shared/state/fetch';
import { useDispatch } from 'shared/state';

export const loadData = (type, response) => ({ type: type, payload: response });

export const useAuth = () => {
    const [cookies, setCookie, removeCookie] = useCookies(['user_auth']);
    const dispatch = useDispatch();

    const clearAuthData = () => {
        cookies && removeCookie('user_auth');
        dispatch(loadData(actionTypes.LOGOUT_USER, { user: {} }));
    }

    const authLogin = async (params={}) => {
        return makeAPIRequest('login', 'POST', params)
            .then((response) => {
                if (response.result) {
                    /* Everything is OK
                    * Set a cookie with user info to persist the login session */
                    cookies && setCookie('user_auth', response.result.user, { maxAge: response.result.expires_in, path: '/' });
                    dispatch(loadData(actionTypes.LOGGED_IN_USER, response.result.user));

                    // Clear any notification still active
                    toast.dismiss();
                    return { logged_in: true , result: response.result.user.role };

                } else {
                    /* Something went wrong, the component will handle it */
                    return { logged_in: false, result: response };
                }
            });
    }

    const authLogout = async () => {
        return makeAPIRequest('logout', 'POST')
            .then((response) => {
                if(response) {
                    clearAuthData();
                    // return message from server
                    return response.result.message;
                }
                return false;
            });
    }

    const authForgotPassord = async (email={}) => {
        return makeAPIRequest('forgot-password', 'POST', email)
            .then((response) => {
                if(response) {
                    console.log('forgot password ', response)
                    // return message from server
                    return response;
                }
                return false;
            });
    }

    return { authLogin, authLogout, authForgotPassord, clearAuthData };
};

/* Function to handle Auth Token when fetching data */
export const useTokenStatus = () => {
    const { clearAuthData } = useAuth();

    const handleError = (message) => {
        const messageText = message ? message : 'Something went wrong.';

        toast.error(messageText, {
            toastId: "auth_token",
            autoClose: 5000,
            position: toast.POSITION.TOP_CENTER
        });
    }

    const handleWarning = (message) => {
        //const messageText = message ? message : 'Your session expired.';
        const messageText = 'Your session expired.';

        toast.warning(messageText, {
            toastId: "auth_token",
            autoClose: 5000,
            position: toast.POSITION.TOP_CENTER
        });
    }

    const handleTokenStatus = (response={}) => {
        const { status, message } = response;

        if(status && status === 'error') {
            handleError(message);
        }

        if(status && status === 'warning') {
            handleWarning(message);
        }

        // Always clear our React cookie, it forces the user to login again
        clearAuthData();
    }

    return { handleTokenStatus };
}
